import type { ReactNode } from "react";
import { useEffect } from "react";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";

import version from "../../../version";

export function PostHogProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const posthogKey = import.meta.env.VITE_POSTHOG_KEY;

    if (posthogKey) {
      posthog.init(posthogKey, {
        api_host: "https://rocketrent.com/ingest",
      });

      posthog.register({
        app_version: version,
      });
    } else {
      console.log("PostHog key is not defined");
    }
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
